import { JobStatusType } from "@nova/constants"
import { VideoFlight } from "@nova/protobuf"
import { selectVideoFlightById } from "features/entity-caching/flights/selectors"
import { zoomToShowPoint } from "features/map/control/slice"
import store from "integrations/redux/store"
import { selectVideoEvents } from "plugins/Video/FMV/VideoSlice"

export const zoomToVideo = (entity: VideoFlight) => {
    const localMetadata = selectVideoEvents(entity.id)(store.getState())
    if (localMetadata) {
        return store.dispatch(
            zoomToShowPoint({
                lng: localMetadata[0][0],
                lat: localMetadata[0][1],
                zoomLevel: 14,
            })
        )
    }
    const flight = selectVideoFlightById(entity.id)(store.getState())
    const startingPosition = flight?.startingPosition
    if (!startingPosition || !startingPosition.latitude || !startingPosition.longitude) return
    store.dispatch(
        zoomToShowPoint({
            lng: startingPosition.longitude,
            lat: startingPosition.latitude,
            zoomLevel: 14,
        })
    )
}

export const shouldHideVideoInspectorPanel = (entity: VideoFlight) => {
    return (entity.job?.status || 0) < JobStatusType.COMPLETED
}
